// components/AgeGroupSection.jsx
import ProgramCard from './ProgramCard';

const AgeGroupSection = ({ ageGroup, programs }) => {
  const { age, title, description, color } = ageGroup;

  return (
    <section className={`rounded-lg p-4 md:p-6 ${color} shadow-md`}>
      <div className="mb-4 md:mb-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2">
          <h2 className="text-xl md:text-2xl font-bold text-gray-800">{title}</h2>
          <span className="px-3 py-1 bg-white rounded-full text-xs md:text-sm font-medium text-gray-700 shadow-sm self-start sm:self-auto">
            {age}
          </span>
        </div>
        <p className="text-sm md:text-base text-gray-600">{description}</p>
      </div>

      {programs.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          No programs available for this age group at the moment.
        </div>
      ) : (
        <div className="grid gap-6 lg:grid-cols-2">
          {programs.map((program, index) => (
            <ProgramCard key={program.id} program={program} />
          ))}
        </div>
      )}
    </section>
  );
};

export default AgeGroupSection;